/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLocationSearching = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0 2c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm4.707 3.293a1 1 0 0 1 .222 1.078l-4 10a1 1 0 0 1-.928.63l-.068-.003a1 1 0 0 1-.903-.755l-1.058-4.215-4.215-1.059a1 1 0 0 1-.128-1.898l10-4a1.002 1.002 0 0 1 1.078.222zm-2.502 2.502-4.967 1.987 1.8.452a1 1 0 0 1 .728.727l.452 1.801z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLocationSearching as LocationSearching };
